import React,{Fragment, Component} from 'react';
import {Link} from 'react-router-dom';
import Header from '../Layout/Header';
import Footer from '../Layout/Footer';
import PageTitle from '../Layout/PageTitle';
//images
import bnr1 from './../../images/line2.png';
import clsimg1 from './../../images/classes/pic1.jpg';
import clsimg2 from './../../images/classes/pic2.jpg';
import clsimg3 from './../../images/classes/pic3.jpg';
import clsimg4 from './../../images/classes/pic4.jpg';
import clsimg5 from './../../images/classes/pic5.jpg';


const classesBlog =[
	{ images: clsimg1, title: 'Play Group', age:"2-3",  },	
	{ images: clsimg2, title: 'Pre Nursery', age: "3-4", },	
	{ images: clsimg3, title: 'Nursery', age: "4-5", },	
	{ images: clsimg4, title: 'KG', age: "5-6", },
	// { images: clsimg5, title: 'Daycare', age: "1.5+", },
];

class Classes extends Component{
	render(){
		return(
			<Fragment>
				<Header />
				<div className="page-content">
					<PageTitle  motherMenu="Classes"  activeMenu="Classes" />
					<div className="content-block">
						<div className="section-full bg-white content-inner" style={{backgroundImage:"url("+ bnr1+")", backgroundSize:"contain",backgroundRepeat: "no-repeat",backgroundPosition: "center"}}>
							<div className="container">

								<div className="class-info">
									<div className="dlab-post-title ">
										<h2 className="post-title m-t0" style={{ color: "#ed5ab0" }}>Classroom</h2>
									</div>

									<div className="dlab-post-text">
										<p>
											At Kimaya, we realize that your child will spend a substantial amount of time of his/her day in the classroom, with that in mind,
											we have designed our classrooms to be roomy, safe and engaging. The design of a room and the picture that one sees during
											the day leaves a bigger impact on one’s mind than we realize, therefore, we thoughtfully pick the poster and picture boards
											to be put up on the wall to accelerate learning, not only this, we have gone a step a head to even choose specific
											colors of the walls which, supported by research, enhance the happiness of children and keep them more active.
										</p>
									</div>
								</div>
								

								<div className="row sp40">
									{classesBlog.map((data, index)=>(
										<div className="col-lg-4 col-md-6 col-sm-6" key={index}>
											<div className="class-item">
												<div className="class-media"> 
													<img src={data.images} alt=""/>
													<p>
														<span>Class Time:</span> 
														08:00 am - 5:30 pm
													</p>
												</div>
												<div className="class-info">
													<h4 style={{ color:"#ed5ab0"}}>{data.title}</h4>
													{/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit nulla felis ipsum.</p> */}
													<ul className="schedule">
														<li className="bg-blue class-size"><span>Class Size</span> <span>10 - 20</span> </li>
														<li></li>
														<li className="bg-green years-old"><span>Years Old</span> <span> &nbsp;  &nbsp; {data.age}</span> </li>
														{/* <li className="bg-orange tution"><span>Tution Fee</span> <span>$1500</span> </li> */}
													</ul>
												</div>
											</div>
										</div>
									))}	
								</div>
							</div>
						</div>	
					</div>
				</div>
				<Footer />
			</Fragment>
		)
	}
}
export default Classes;